
/**
 * Call this function to indicate that a given code path should never be called
 * from unit tests. Use this for code which reads environment variables to
 * construct clients for communicating with real cloud infrastructure.
 *
 * All tests that trigger calls to this function should be rewritten to inject
 * stub implementations of cloud resources, rather than allowing this function
 * to be called during unit testing.
 */
export function disallowUnitTest() {
  if (isInUnitTestEnv()) {
    throw new Error('Disallowed in unit tests or when MIMIR_STAGE is missing');
  }
}

/**
 * Can be used to check whether the code is currently running under unit-test environment
 */
export const isInUnitTestEnv = () => {
  const stage = process.env['MIMIR_STAGE'];
  return (stage == 'ut' || stage == null);
};
